import { render, staticRenderFns } from "./DrawArea.vue?vue&type=template&id=d78fccac&lang=pug"
import script from "./DrawArea.vue?vue&type=script&lang=js"
export * from "./DrawArea.vue?vue&type=script&lang=js"
import style0 from "./DrawArea.vue?vue&type=style&index=0&id=d78fccac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports